var exports = {
  "p": "x04b3a21e--1bdc24--list",
};

module.exports = exports;
